import { render, staticRenderFns } from "./Item35Poll.vue?vue&type=template&id=d08bb9ec&"
import script from "./Item35Poll.vue?vue&type=script&lang=js&"
export * from "./Item35Poll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports